import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ButtonAnimated.module.css'
import styleNames from '../../utils/styleNames'

export default class ButtonAnimated extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    status: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }
  constructor (props) {
    super(props)
    this.state = {
      focus: false
    }
  }
  _toggleFocus () {
    this.setState({ focus: !this.state.focus })
  }
  render () {
    return (      
        <div className={styleNames(styles, `${this.props.status} button ${this.props.disabled ? 'disabled' : ''} ${this.state.focus ? 'focus' : ''} ${this.props.loading ? 'loading' : ''}`)}>
          <button
            onBlur={this._toggleFocus.bind(this)}
            onClick={this.props.onClick}
            onFocus={this._toggleFocus.bind(this)}>
            <span>{this.props.text}</span>
          </button>
          <img src="/static/img/ajax-loader-orange-bg.gif"/>
        </div>
      
    )
  }
}
